export enum Knowbe4CampaignStatus {
  Created = 'Created',
  Enrolling = 'Enrolling',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
}
